/* Danish CVR number validation*/
export const cvr = (value: string): boolean => {
    // Ensure it's a string and remove any spaces or dashes
    const cleaned: string = String(value).replace(/[^0-9]/g, "");

    // Check length is exactly 8 digits
    if (cleaned.length !== 8) return false;

    // Weights for modulus 11 check
    const weights: number[] = [2, 7, 6, 5, 4, 3, 2, 1];

    // Calculate sum
    let sum: number = 0;
    for (let i = 0; i < 8; i++) {
        sum += parseInt(cleaned.charAt(i)) * weights[i];
    }

    // Valid if divisible by 11
    return sum % 11 === 0;
};
